<template>
  <h2
    tabindex="0"
    role="button"
    @click="toggleFaq"
    @keyup.enter="toggleFaq"
    @keyup.space="toggleFaq"
    @keydown.enter.prevent
    @keydown.space.prevent
  >
    <slot />
  </h2>
</template>

<script lang="ts" setup>
import { inject } from "vue";

const toggleFaq = inject<() => void>("toggleFaq")!;
</script>
